import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["href", "target"]
const _hoisted_2 = {
  key: 0,
  class: "external-link"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("polygon", { points: "22,2 13,2 13,4 18.6,4 11.3,11.3 12.7,12.7 20,5.4 20,11 22,11" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("polygon", { points: "19,20 4,20 4,5 10,5 10,3 2,3 2,3 2,22 2,22 21,22 21,14 19,14" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", _mergeProps({
    href: _ctx.to,
    target: _ctx.target
  }, _ctx.$attrs), [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.externalIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([
						'external-link__icon',
						{ 'external-link__icon__small': _ctx.smallIcon },
						{ 'external-link__icon__x-small': _ctx.xSmallIcon },
						{ 'external-link__icon__alternate': _ctx.alternateIcon },
					]),
              version: "1.1",
              id: "Lag_1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              x: "0px",
              y: "0px",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              style: {"enable-background":"new 0 0 24 24"},
              "xml:space": "preserve"
            }, _hoisted_5, 2))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 16, _hoisted_1))
}